import Vue from "vue";
import { MinicartItem } from "./miniCartProducts";

/**
 * MiniCart Brand Component
 */
const MinicartBrand = Vue.component("minicart-brand", {
    template: `
        <div class="minicart-brand">
            <div class="minicart-brand-header">
                <span v-for="(icon, key) in brandsIcons">
                    <span v-html="icon" v-if="key == brand.productBrandID"/>
                </span>
                <span class="ml-3"> {{itemsCount}} {{resources.products}}</span>
                <span @click="visible = !visible">
                    <span v-html="arrowUpIcon" class="float-right" v-if="visible" />
                    <span v-html="arrowDownIcon" class="float-right" v-if="!visible" />
                </span>
            </div>
            <minicart-item v-for="item in brand.items"
                :key="item.id"
                :item="item"
                :resources="resources"
                :trashIcon="trashIcon"
                :quantityInputIcons="quantityInputIcons"
                :brandID="brand.productBrandID"
                :visible="visible"
                v-if="item" />
        </div>
    `,
    components: {
        MinicartItem
    },
    props: ["itemsSortedByBrand", "brand", "resources", "trashIcon", "quantityInputIcons", "brandsIcons", "arrowUpIcon", "arrowDownIcon", "brandID"],
    data() {
        return {
            visible: this.brand.productBrandID == this.brandID || this.itemsSortedByBrand.length == 1 ? true : false
        };
    },
    computed: {
        itemsCount: function () {
            var count = 0;

            this.brand.items.forEach(item => {
                if (item.id != this.resources.plasticBagID) {
                    count++;
                }
            });

            return count;
        }
    }
});

export { MinicartBrand };
